/** Admin login alias — reuses the staff email+password form. */
import StaffLoginPage from '@/pages/LoginPage';
export default function AdminLoginPage() { return <StaffLoginPage />; }
